import { InputBase } from "@mantine/core";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { type ReactElement, forwardRef } from "react";

interface DropdownTriggerProps {
  opened: boolean;
  toggle: () => void;
  leftSection: ReactElement;
  text: string;
}

// Imitate the trigger of Mantine's <Select />.
export const DropdownTrigger = forwardRef<
  HTMLInputElement,
  DropdownTriggerProps
>(({
  opened,
  toggle,
  leftSection,
  text,
}, ref) => (
  <InputBase
    pointer
    readOnly
    ref={ref}
    value={text}
    onClick={toggle}
    leftSection={leftSection}
    rightSection={opened ? <IconChevronUp /> : <IconChevronDown />}
  />
));

DropdownTrigger.displayName = "DropdownTrigger";
